import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import StatusBadge from "../components/StatusBadge";
import { Briefcase, ExternalLink, Trash2 } from "lucide-react";

export default function CandidateDashboard() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/applications/mine").then((r) => setApps(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const withdraw = async (id) => {
    if (!window.confirm("Withdraw this application? This cannot be undone.")) return;
    try { await api.delete(`/applications/${id}`); load(); }
    catch (e) { alert(e.response?.data?.detail || e.message); }
  };

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-12">
      <div className="label-eyebrow">Candidate dashboard</div>
      <h1 className="font-display font-black text-5xl mt-3 tracking-tight">Your applications.</h1>
      <p className="text-[#5C5C5C] mt-2">Track every move from <em>Submitted</em> to <em>Accepted</em>.</p>

      <div className="mt-10">
        {loading && <div className="text-[#5C5C5C]">Loading…</div>}
        {!loading && apps.length === 0 && (
          <div data-testid="no-applications" className="border border-[#E2E0D8] p-10 text-center">
            <Briefcase className="w-10 h-10 mx-auto text-[var(--brand-primary)]" />
            <h2 className="font-display font-bold text-2xl mt-4">No applications yet.</h2>
            <p className="text-[#5C5C5C] mt-2">Browse open roles and apply to your first one.</p>
            <Link to="/jobs" className="btn-terra mt-6 inline-flex">Browse roles</Link>
          </div>
        )}
        <div className="grid gap-px bg-[#E2E0D8] border border-[#E2E0D8]">
          {apps.map((a) => (
            <div key={a.application_id} data-testid={`app-row-${a.application_id}`}
              className="bg-[#FDFCF8] p-6 flex items-center justify-between gap-4">
              <div className="min-w-0">
                <div className="label-eyebrow">{a.company}</div>
                <h3 className="font-display font-bold text-xl mt-1">{a.job_title}</h3>
                <div className="text-xs text-[#5C5C5C] mt-1">Applied {new Date(a.created_at).toLocaleDateString()}</div>
              </div>
              <div className="flex items-center gap-4">
                <StatusBadge status={a.status} />
                <Link to={`/jobs/${a.job_id}`} className="text-sm font-semibold hover:text-[var(--brand-primary)] inline-flex items-center gap-1">
                  View role <ExternalLink className="w-3.5 h-3.5" />
                </Link>
                <button onClick={() => withdraw(a.application_id)} data-testid={`withdraw-${a.application_id}`} title="Withdraw" className="text-sm font-semibold text-[#5C5C5C] hover:text-[var(--brand-primary)] inline-flex items-center gap-1">
                  <Trash2 className="w-3.5 h-3.5" /> Withdraw
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
